import { render, staticRenderFns } from "./NoLoginLayout.vue?vue&type=template&id=4588123b&"
import script from "./NoLoginLayout.vue?vue&type=script&lang=js&"
export * from "./NoLoginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports